import {
  IAlertNotification,
  IAlertNotificationContentItem,
  IAlertNotificationItem,
  IAlertNotificationOwner,
} from 'redhotpie-shared-lib/interfaces/INotification';
import { TYPE_OF_NOTIFICATIONS_NOTIFICATIONS } from '../constants/category';
import * as utils from '../functions/utils';
import eventDetail from './eventDetail';
import Photo from './photo';
import { IMainPhoto, IUserCommon } from 'redhotpie-shared-lib/interfaces/IUser';
import { IContentItem } from 'redhotpie-shared-lib/interfaces/ICommunity';
import { IActor } from 'redhotpie-shared-lib/interfaces/INewFeed';

export interface IApiNotificationPhoto {
  PhotoID: number;
  Height: number;
  Width: number;
  IsUserImage: boolean;
  IsPublic: boolean;
  Classification: any;
  ThumbUrl: string;
  FullUrl: string;
}

export interface IApiNotificationOwner {
  UserID: number;
  Username: string;
  MemberType: any;
  ProfilePhoto: IApiNotificationPhoto;
  Location: string;
  MemberTypeTitle: string;
}

export interface IApiNotificationContentItem {
  ID: number;
  Title: string;
  IsMemberLike: boolean;
  Owner: IApiNotificationOwner;
  ParentType: any;
}

export interface IApiNotification {
  UserID?: number;
  TypeID?: string;
  DateCreated?: string | number;
  ContentItem?: IApiNotificationContentItem;
  Profile?: any;
}

export interface IApiEventInterest {
  EventID?: number;
  EventInterestID?: number;
  DateExpressed?: string;
  Profile?: any;
  EventTitle?: string;
}

export default class alertNotification {
  userId: number | null;
  typeId: string;
  dateCreated: string | number;
  contentItem: any;
  destination: any;

  constructor() {
    this.userId = null;
    this.typeId = '';
    this.dateCreated = '';
    this.contentItem = {};
    this.destination = null;
  }

  static mappingPhoto(_obj: IApiNotificationPhoto): IMainPhoto {
    const obj = {
      photoId: null as number | null,
      height: 0,
      width: 0,
      isUserImage: false,
      isPublic: false,
      classification: null as any,
      thumbUrl: '',
      fullUrl: '',
    };
    obj.photoId = _obj.PhotoID;
    obj.height = _obj.Height ? _obj.Height : 0;
    obj.width = _obj.Width ? _obj.Width : 0;
    obj.isUserImage = _obj.IsUserImage ? _obj.IsUserImage : false;
    obj.isPublic = _obj.IsPublic ? _obj.IsPublic : false;
    obj.classification = _obj.Classification;
    obj.thumbUrl = _obj.ThumbUrl ? _obj.ThumbUrl : '';
    obj.fullUrl = _obj.FullUrl ? _obj.FullUrl : '';
    return obj;
  }

  static mappingContentItem(_obj: IApiNotificationContentItem): IAlertNotificationContentItem {
    const obj: IAlertNotificationContentItem = {
      id: -1,
      title: '',
      isMemberLike: false,
      owner: undefined,
      parentType: '',
    };
    obj.id = _obj.ID ? _obj.ID : -1;
    obj.title = _obj.Title ? _obj.Title : '';
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.owner = _obj && _obj.Owner ? alertNotification.mappingOwner(_obj.Owner) : undefined;
    obj.parentType = _obj.ParentType ? _obj.ParentType : '';
    return obj;
  }

  static mappingOwner(_obj: IApiNotificationOwner): IAlertNotificationOwner {
    const obj: IAlertNotificationOwner = {
      userId: -1,
      userName: '',
      memberType: '',
      profilePhoto: undefined,
      location: '',
      memberTypeTitle: '',
    };
    obj.userId = _obj.UserID;
    obj.userName = _obj.Username ? _obj.Username : '';
    obj.memberType = _obj.MemberType;
    obj.profilePhoto = _obj.ProfilePhoto ? alertNotification.mappingPhoto(_obj.ProfilePhoto) : undefined;
    obj.location = _obj.Location || '';
    obj.memberTypeTitle = _obj.MemberTypeTitle ? _obj.MemberTypeTitle : '';

    return obj;
  }

  static mappingObject(_obj: IApiNotification, isAlert?: boolean): IAlertNotificationItem {
    let obj = new alertNotification();
    obj.userId = _obj.UserID || null;
    obj.typeId = _obj.TypeID ? _obj.TypeID : '';
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : 0;
    obj.contentItem = _obj.ContentItem ? alertNotification.mappingContentItem(_obj.ContentItem) : {};
    if (isAlert) {
      obj.destination = utils.addDestinationAlertNotification(_obj.TypeID);
    }

    // Using cast to any to access dynamic props if necessary, though cleanObjectKeys should handle typed object too
    obj = (utils as any).cleanObjectKeys(Object.keys(new alertNotification()), obj);
    return obj;
  }

  static mappingObjects(_data: IApiNotification[], isAlert?: boolean): IAlertNotificationItem[] {
    const data: alertNotification[] = [];
    _data.forEach(_item => {
      switch (_item.TypeID) {
        case TYPE_OF_NOTIFICATIONS_NOTIFICATIONS.FRIEND_REQUEST_ACCEPTED:
        case TYPE_OF_NOTIFICATIONS_NOTIFICATIONS.VALIDATION_ACCEPTED: {
          if (!isAlert) {
            const item = alertNotification.mappingObject(_item, false);
            data.push(item);
          }
          break;
        }
        case TYPE_OF_NOTIFICATIONS_NOTIFICATIONS.WELCOME_MESSAGE_TOUR: {
          // Note: This returns a plain object structure matching the shape effectively
          const item: any = {
            typeId: _item.TypeID,
            dateCreated: _item.DateCreated,
            userId: _item.UserID,
          };
          if (item) {
            data.push(item);
          }
          break;
        }
        default:
          const item = alertNotification.mappingObject(_item, isAlert);
          data.push(item);
          break;
      }
    });
    return data;
  }

  static mappingListEventInterest(_objs: IApiEventInterest[]): IAlertNotification[] {
    const objs: any[] = [];
    _objs.forEach(data => {
      const d = alertNotification.mappingEventInterest(data);
      objs.push(d);
    });
    return objs;
  }

  static mappingUser(user: any): IUserCommon {
    const obj = {
      age1: null,
      age2: null,
      ageTitle: '',
      countryID: null,
      isAdmin: null,
      isDiamond: false,
      isOnline: false,
      isViewable: null,
      location: '',
      mainPhoto: {} as Photo | {},
      matchingInterests: null,
      memberID: null,
      userId: null,
      memberLevel: null,
      memberLevelType: null,
      memberLevelUserProfile: null,
      memberType: null,
      memberTypeTitle: {},
      userName: '',
      userType: null,
      countryId: 0,
    };
    obj.age1 = user.Age1 !== null ? user.Age1 : null;
    obj.age2 = user.Age2 !== null ? user.Age2 : null;
    obj.ageTitle = user.AgeTitle || '';
    obj.countryID = user.CountryID !== null ? user.CountryID : null;
    obj.isAdmin = user.IsAdmin !== null ? user.IsAdmin : null;
    obj.isDiamond = user.IsDiamond || false;
    obj.isOnline = user.IsOnline || false;
    obj.isViewable = user.IsViewable !== null ? user.IsViewable : null;
    obj.location = user.Location || '';
    obj.mainPhoto = user.MainPhoto !== null ? Photo.mappingObject(user.MainPhoto) : {};
    obj.matchingInterests = user.MatchingInterests !== null ? user.MatchingInterests : null;
    obj.memberID = user.MemberID !== null ? user.MemberID : null;
    obj.memberLevel = user.MemberLevel !== null ? user.MemberLevel : null;
    obj.memberLevelType = user.MemberLevelType !== null ? user.MemberLevelType : null;
    obj.memberLevelUserProfile = user.MemberLevelUserProfile !== null ? user.MemberLevelUserProfile : null;
    obj.memberType = user.MemberType !== null ? user.MemberType : null;
    obj.memberTypeTitle = user.MemberTypeTitle !== null ? eventDetail.mappingMemberTypeTitle(user.MemberTypeTitle) : {};
    obj.userName = user.Username !== null ? user.UserName : null;
    obj.userType = user.UserType !== null ? user.UserType : null;
    obj.userId = user.MemberID !== null ? user.MemberID : null;

    return obj;
  }

  static mappingEventInterest(_obj: IApiEventInterest): IAlertNotification {
    const obj: IAlertNotification = {
      eventId: -1,
      eventInterestID: -1,
      dateExpressed: '',
      user: undefined,
      eventTitle: '',
    };
    obj.eventId = _obj.EventID ? _obj.EventID : -1;
    obj.eventInterestID = _obj.EventInterestID ? _obj.EventInterestID : -1;
    obj.dateExpressed = _obj.DateExpressed ? _obj.DateExpressed : '';
    obj.user = _obj.Profile ? alertNotification.mappingUser(_obj.Profile) : undefined;
    obj.eventTitle = _obj.EventTitle ? _obj.EventTitle : '';

    return obj;
  }
}
